exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.header-bg[data-v-848e8f78] {\n    background-color: #323336;\n}\n", ""]);

// exports
